import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"

const DataSecurity = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>9. Data Security Measures</Typography>
        <Typography  sx={{ fontSize: '1.1rem' }}>We implement technical and organizational safeguards to protect your data:
</Typography>
        <List>
            <ListItem>
                <ListItemText>
                   • Encrypted transmission (SSL/TLS) and secure backend servers
                </ListItemText>
            </ListItem>
              <ListItem>
                <ListItemText>
• Daily data backups and disaster recovery processes
                </ListItemText>
            </ListItem>
              <ListItem>
                <ListItemText>
• Role-based access controls (RBAC)
                </ListItemText>
            </ListItem>
              <ListItem>
                <ListItemText>
• Secure APIs and internal audit trails
                </ListItemText>
            </ListItem>
              <ListItem>
                <ListItemText>
• No third-party analytics or cookies
                </ListItemText>
            </ListItem>
        </List>
        <Divider sx={{ my: 2 }} />
    </>
  )
}

export default DataSecurity